import {ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {AladinService} from "../aladin.service";
import {tap} from "rxjs/operators";
import {NgbDropdown} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'asax-sky-view-aladin-configuration',
  templateUrl: './aladin-configuration.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AladinConfigurationComponent {
  @ViewChild('dropdown', {static: true}) dropdown: NgbDropdown;

  @Output() outDisplayCells = new EventEmitter<boolean>();
  @Output() outDisplayFootprints = new EventEmitter<boolean>();
  @Output() outDisplaySkyObjects = new EventEmitter<boolean>();

  displayCells = true;
  displayFootprints = true;
  displaySkyObjects = true;

  constructor(private readonly aladinService: AladinService) {
    this.aladinService.getMouseClick().pipe(
      tap(() => this.dropdown?.close()),
    ).subscribe();
  }

  displayCellsValueChanged(): void {
    this.displayCells = !this.displayCells;
    this.outDisplayCells.emit(this.displayCells);
  }

  displayFootprintsValueChanged(): void {
    this.displayFootprints = !this.displayFootprints;
    this.outDisplayFootprints.emit(this.displayFootprints);
  }

  displaySkyObjectsValueChanged(): void {
    this.displaySkyObjects = !this.displaySkyObjects;
    this.outDisplaySkyObjects.emit(this.displaySkyObjects);
  }
}
